import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { withComponents } from '../components/Context';
import BaseSection from './BaseSection';

class HeroImage extends PureComponent {
  render() {
    const { image, components, parallax, maxWidth, ctaUrl, ...props } = this.props;
    const { FigureImage } = components;
    return (
      <BaseSection className="hero" {...props} block={this.props} hasHeader={false}>
        <div className="hero-body">
          <FigureImage src={image} parallax={parallax} maxWidth={maxWidth} ctaUrl={ctaUrl} />
        </div>
      </BaseSection>
    );
  }
}

HeroImage.defaultProps = {
  parallax: 'none',
  maxWidth: 1920,
  ctaUrl: undefined,
};

HeroImage.propTypes = {
  components: PropTypes.object.isRequired,
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  parallax: PropTypes.oneOf(['', 'none', 'normal', 'fullpage']),
  maxWidth: PropTypes.number,
  ctaUrl: PropTypes.string,
};

export default withComponents(HeroImage);
